module.exports = require("@splunk/react-icons/enterprise/BarStacked100");